import React, { useState } from 'react';
import { Menu, X, Phone, MessageSquare } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 bg-[#1B2A4A] shadow-md" data-id="element-213">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between" data-id="element-214">
        <div className="flex flex-col items-center" data-id="element-215">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/71XGyHSaKA5S5uajSj7G8p/Crown_Logo_-_Edited_-_Edited.png" alt="Crown Inspection Services" className="h-28 w-auto" data-id="element-216" />
          <span className="text-xs text-gray-300 mt-1 text-center" data-id="element-217">
            Lee - Collier - Charlotte Counties
          </span>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-218">
          <a href="#services" className="text-white hover:text-[#D4AF37] font-medium transition-colors duration-200" data-id="element-219">
            Services
          </a>
          <a href="#about" className="text-white hover:text-[#D4AF37] font-medium transition-colors duration-200" data-id="element-220">
            About
          </a>
          <a href="#service-areas" className="text-white hover:text-[#D4AF37] font-medium transition-colors duration-200" data-id="element-221">
            Service Areas
          </a>
          <a href="#testimonials" className="text-white hover:text-[#D4AF37] font-medium transition-colors duration-200" data-id="element-222">
            Testimonials
          </a>
          <a href="#resources" className="text-white hover:text-[#D4AF37] font-medium transition-colors duration-200" data-id="element-223">
            Resources
          </a>
          <a href="#contact" className="text-white hover:text-[#D4AF37] font-medium transition-colors duration-200" data-id="element-224">
            Contact
          </a>
        </nav>
        <div className="hidden md:flex items-center gap-3" data-id="element-225">
          <a href="tel:2396997080" className="flex items-center bg-[#D4AF37] text-[#1B2A4A] py-2 px-4 rounded-md font-bold hover:bg-[#C09F2F] transition-colors duration-200" data-id="element-226">
            <Phone size={18} className="mr-2" data-id="element-227" />
            239-699-7080
          </a>
          <a href="sms:+12396997080?body=Hello, I'm interested in your inspections services." className="flex items-center bg-white text-[#1B2A4A] py-2 px-4 rounded-md font-bold hover:bg-gray-100 transition-colors duration-200" data-id="element-228">
            <MessageSquare size={18} className="mr-2" data-id="element-229" />
            Text Us
          </a>
        </div>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-white" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-230">
          {isMenuOpen ? <X size={24} data-id="element-231" /> : <Menu size={24} data-id="element-232" />}
        </button>
      </div>
      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-[#1B2A4A] px-4 py-5 shadow-lg" data-id="element-233">
          <nav className="flex flex-col space-y-4" data-id="element-234">
            <a href="#services" className="text-white hover:text-[#D4AF37] font-medium transition-colors duration-200" onClick={() => setIsMenuOpen(false)} data-id="element-235">
              Services
            </a>
            <a href="#about" className="text-white hover:text-[#D4AF37] font-medium transition-colors duration-200" onClick={() => setIsMenuOpen(false)} data-id="element-236">
              About
            </a>
            <a href="#service-areas" className="text-white hover:text-[#D4AF37] font-medium transition-colors duration-200" onClick={() => setIsMenuOpen(false)} data-id="element-237">
              Service Areas
            </a>
            <a href="#testimonials" className="text-white hover:text-[#D4AF37] font-medium transition-colors duration-200" onClick={() => setIsMenuOpen(false)} data-id="element-238">
              Testimonials
            </a>
            <a href="#resources" className="text-white hover:text-[#D4AF37] font-medium transition-colors duration-200" onClick={() => setIsMenuOpen(false)} data-id="element-239">
              Resources
            </a>
            <a href="#contact" className="text-white hover:text-[#D4AF37] font-medium transition-colors duration-200" onClick={() => setIsMenuOpen(false)} data-id="element-240">
              Contact
            </a>
            <div className="flex flex-col sm:flex-row gap-3" data-id="element-241">
              <a href="tel:2396997080" className="flex items-center bg-[#D4AF37] text-[#1B2A4A] py-2 px-4 rounded-md font-bold hover:bg-[#C09F2F] transition-colors duration-200 w-fit" data-id="element-242">
                <Phone size={18} className="mr-2" data-id="element-243" />
                239-699-7080
              </a>
              <a href="sms:+12396997080?body=Hello, I'm interested in your inspections services." className="flex items-center bg-white text-[#1B2A4A] py-2 px-4 rounded-md font-bold hover:bg-gray-100 transition-colors duration-200 w-fit mt-3 sm:mt-0" data-id="element-244">
                <MessageSquare size={18} className="mr-2" data-id="element-245" />
                Text Us
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}